import {Component, forwardRef, input, ChangeDetectionStrategy, computed} from '@angular/core';
import {ErrorProvider, ErrorToken} from '../errors/declarations';
import {toObservable} from '@angular/core/rxjs-interop';

@Component({
  selector: 'ms-error',
  template: '',
  providers: [
    {
      provide: ErrorToken,
      useExisting: forwardRef(() => ErrorComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ErrorComponent implements ErrorProvider {
  readonly code = input.required<string>();
  readonly message = input<string>();
  readonly message$ = toObservable(computed(() => this.message() ?? null));

  readonly customError = {
    code: this.code,
    message$: this.message$,
  };
}
